import * as yup from 'yup';
import { useFormik } from 'formik';
import { MouseEvent } from 'react';
import { ValidationMessages } from '../../../../../constants/validationMessages';
import { GeneralLink, RegexRules } from "../../../../../utils";
import { useAuthApi } from '../../../../../apiHooks';
import { useNavigate } from 'react-router-dom';

export const validationSchema = yup.object().shape({
  email: yup
    .string()
    .matches(RegexRules.EMAIL, ValidationMessages.INVALID_EMAIL)
    .required(ValidationMessages.EMPTY_FIELD),
})

export const useRetrievePasswordForm = () => {
  const {resetPassword} = useAuthApi()
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const res = await resetPassword(values.email)
      if (res) {
        formik.resetForm();
        navigate(GeneralLink.LOGIN);
      }

    }
  })

  const confirmForm = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    formik.handleSubmit();
  }

  return {formik, confirmForm}
}
  
  

